import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import "./style.scss";
import { FaRegHandPointer } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <main id="home">
      <Container>
        <Row className='admin_padding'>
          <Col>
            <Link to="/announcements" className='admin_home_btn'>Announcements <FaRegHandPointer /></Link>
            <Link to="/events" className='admin_home_btn'>Events <FaRegHandPointer /></Link>
            <Link to="/sendNotification" className='admin_home_btn'>Send Notification <FaRegHandPointer /></Link>
            <Link to='start_quiz' className='admin_home_btn'>Start Quiz <FaRegHandPointer /></Link>
          </Col>
          <Col>
            <Link to="/sponsers" className='admin_home_btn'>Sponser <FaRegHandPointer /></Link>
            <Link to="/certificates" className='admin_home_btn'>Certificates <FaRegHandPointer /></Link>
            <Link to="/applicant" className='admin_home_btn'>Applicant <FaRegHandPointer /></Link>
            <Link to="/bulletin" className='admin_home_btn'>Bulletin <FaRegHandPointer /></Link>
          </Col>
        </Row>
      </Container>
    </main>
  );
}

export default Home;
